export function getRequestCost(requestGeneratorParams) {
    // try to extract domain from requestGeneratorParams.url and check if it contains Google
    let domain = "";
    try {
        domain = new URL(requestGeneratorParams.url).hostname;
    } catch (e) {
        // do nothing
    }

    if (requestGeneratorParams.proxy_type === 'datacenter' && domain.includes("google")) {
        return 10;
    }

    if (requestGeneratorParams.browser) {
        if (requestGeneratorParams.proxy_type === 'residential') {
            if (requestGeneratorParams.return_page_source) return 50;
            return 125;
        }

        if (requestGeneratorParams.proxy_type === 'datacenter') {
            if (requestGeneratorParams.return_page_source) return 2;
            return 10;
        }
        return 10;
    }

    if (requestGeneratorParams.proxy_type === 'residential') {
        return 25;
    }

    return 1;
}
